/**
 * Kurzer WebAudio-Klingelton (Zweiklang, zwei Wiederholungen) — bewusst
 * synthetisch statt Audio-Asset. Scheitert die Autoplay-Policy, bleibt der
 * Klingel-Toast die primaere Anzeige.
 */
export function playRingTone(): void {
  try {
    const ctx = new AudioContext();
    const master = ctx.createGain();
    master.gain.value = 0.12;
    master.connect(ctx.destination);

    const note = (freq: number, startS: number, durS: number): void => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, ctx.currentTime + startS);
      gain.gain.linearRampToValueAtTime(1, ctx.currentTime + startS + 0.02);
      gain.gain.setTargetAtTime(0, ctx.currentTime + startS + durS, 0.05);
      osc.connect(gain).connect(master);
      osc.start(ctx.currentTime + startS);
      osc.stop(ctx.currentTime + startS + durS + 0.3);
    };

    for (const repeat of [0, 0.6]) {
      note(880, repeat, 0.18);
      note(660, repeat + 0.2, 0.18);
    }
    window.setTimeout(() => void ctx.close(), 1600);
  } catch {
    // Kein Audio verfuegbar — Toast reicht
  }
}
